import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import Button from 'components/controls/Button';
import _validator from 'modules/validator';

import { routesBiometricAdmin } from '../routes/Routes';
import _authService from 'modules/AuthService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import { PROJECT_LOGO } from '../constants/constants';

class BiometricAdminLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adminID: "",
            adminIDState: "",
            password: "",
            passwordState: "",
            passwordError: "",
            isLoginSuccess: "",
            isLoading: false
        };
        this.homePageLink = React.createRef();
    }

    componentDidMount() {
        
        _authService.clearSessionHist();
    }

    onTextChange = ({ target: { name, value } }) => {
        switch (name) {
            case "adminID":
                if (_validator.verifyBlank(value)) {
                    this.setState({
                        [name + "State"]: "success",
                        [name + "Error"]: ""
                    });
                } else {
                    this.setState({
                        [name + "State"]: "error",
                        [name + "Error"]: "Invalid Biometric Admin User Name"
                    });
                }
                break;

            case "password":
                if (_validator.verifyBlank(value)) {
                    this.setState({
                        [name + "State"]: "success",
                        [name + "Error"]: ""
                    });
                } else {
                    this.setState({
                        [name + "State"]: "error",
                        [name + "Error"]: "Invalid Password"
                    });
                }
                break;

            default:
                this.setState({ [name + "State"]: "success" });
        }
        this.setState({ [name]: value, isLoginSuccess: "" });
    }

    handleLogin = async (ev) => {
        ev.preventDefault();
        if (this.state.adminIDState === "success" && this.state.passwordState === "success" && this.state.adminID.trim() != "" && this.state.password.trim() != "") {
            this.setState({ isLoading: true });
            try {
               // debugger
                const response = await _authService.biometricAdminLogin({ email: this.state.adminID.trim(), Password: this.state.password.trim() });
               // debugger
                console.log("response",response.data); 
                console.log(response.status);         
                if (response.status == 200 && response.data.Id ) {  //&& response.data.Id
                    _authService.setBiometricAdminSessionData(response.data);
                  //  debugger
                    window.setTimeout(() => {
                        this.setState({ isLoading: false })
                        this.homePageLink.current.click();
                    }, 1000);
                }
                else {
                    this.setState({ isLoading: false })
                    _notification.showMessage('error', response.data.Message);
                }
            } catch (e) {
                console.log("te");
                this.setState({ isLoading: false });
            }
        }
        else {
            if (this.state.adminIDState === "") {
                this.setState({ adminIDState: "error", adminIDError: "Invalid Biometric Admin User Name" });
            }
            if (this.state.passwordState === "") {
                this.setState({ passwordState: "error", passwordError: "Invalid Password" });
            }
        }
    }


    render() {
        return (<>

            <div className="admin-login backadmin d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <form onSubmit={this.handleLogin} className="d-flex ml-3 mr-3 justify-content-center" >
                    <div className="gl-bxbr p-4 admin-login-wrap">
                        <div className="login-form-wrap position-relative w-100 align-items-center m-auto  form-wrap d-flex align-items-center justify-content-center">
                            <div className="login-form-inner-wrap w-100 d-flex align-items-center justify-items-center flex-column">
                                <img alt='PROJECT_LOGO' src={PROJECT_LOGO} className="projectLogoSizeWidth mb-4" style={{ maxWidth: "100% !important" }} />
                                <h3 className="mb-4">Welcome to Online User Registration<br /><small className="primeryText">Enter biometric admin credentials to login into system</small></h3>

                                <div className="login-sec mt-3 w-100">
                                    <MyInput
                                        wrapClass="mt-2"
                                        key="adminID"
                                        type="text"
                                        value={this.state.adminID}
                                        name="adminID"
                                        onChange={this.onTextChange}
                                        placeholder="Biometric Admin User Name"
                                        heading="Biometric Admin User Name"
                                        isRequired={false}
                                        errorState={this.state.adminIDState}
                                        errorMessage={this.state.adminIDError}
                                    />
                                    <MyInput
                                        wrapClass="mt-2"
                                        type="password"
                                        value={this.state.password}
                                        name="password"
                                        onChange={this.onTextChange}
                                        placeholder="Enter Password"
                                        heading="Password"
                                        isRequired={false}
                                        errorState={this.state.passwordState}
                                        errorMessage={this.state.passwordError}
                                    />
                                </div>

                                <div className="forget-sec w-100 text-center mt-2">
                                    <Button
                                        type="submit"
                                        className="button-global button-primary mb-3 autoHeight"
                                        value="Login"
                                    ></Button>
                                </div>
                            </div>
                        </div>
                    </div>

                     <a href={routesBiometricAdmin.initializedNSDL.basePath} hidden ref={this.homePageLink} onClick={() => { this.props.history.push(routesBiometricAdmin.initializedNSDL.basePath) }}></a>
                    {this.state.isLoading && <LoadingSpinner />} 

                 </form>
            </div>

        </>
        );
    }
}

export default BiometricAdminLogin;